import { render, staticRenderFns } from "./PortalDocumentsTab.vue?vue&type=template&id=484b3b92&"
import script from "./PortalDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./PortalDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports